<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    var page_area = [
      "関東",
      "中京",
      "九州",
      "大阪",
      "南大阪",
      "兵庫",
      "奈良",
      "和歌山",
      "滋賀",
      "京都"
    ];
    if (page_area.includes(this.$route.params.id)) {
      this.$emit("getId", this.$route.params.id);
    }
    this.$router.push("/");
  }
};
</script>